export default class FiltroMonitoramento {
  constructor(
    idCliente = "",
    email = "",
    ncm = "",
    idMva = 0,
    piscofins = true,
    ipi = true,
    icms = true,
    isencoes = true,
    beneficios = true,
    mva = false
  ) {
    this.idCliente = idCliente;
    this.email = email;
    this.ncm = ncm;
    this.idMva = idMva;
    this.piscofins = piscofins;
    this.ipi = ipi;
    this.icms = icms;
    this.isencoes = isencoes
    this.beneficios = beneficios
    this.mva = mva;
  }

  validaDados() {
    if (this.idCliente && this.ncm && (this.piscofins || this.ipi || this.icms || this.isencoes || this.beneficios))
      return true;
    return false;
  }

  validaCategoria() {
    if (this.piscofins || this.ipi || this.icms || this.isencoes || this.beneficios) return true;
    return false;
  }

  validaEmail() {
    if (this.email) return true;
    return false;
  }
}
